/* eslint-disable react/react-in-jsx-scope */
import { useTranslator } from '@bluebeam/react-i18n';
import { FC, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import UploadsList from './UploadsList';

interface Props extends WithAppStoreProps, RouteComponentProps {}

const UploadsTab: FC<Props> = ({ actions }) => {
  const { translate } = useTranslator(['toastText']);
  useEffect(() => {
    const toastText = {
      fileUploadError: {
        title: translate('toastText:fileUploadError.title'),
        message: translate('toastText:fileUploadError.message'),
      },
      drawingsReadyForReview: {
        title: translate('toastText:drawingsReadyForReview.title'),
        message: translate('toastText:drawingsReadyForReview.message'),
      },
      fileUploadSuccess: {
        title: translate('toastText:fileUploadSuccess.title'),
        message: translate('toastText:fileUploadSuccess.message'),
      },
    };
    actions.getProcessingStatuses(toastText);
  }, []);
  return (
    <div id="drawing-uploads-tab" className="m4">
      <UploadsList />
    </div>
  );
};

export default withAppStore(UploadsTab);
